import { SpotOverviewSkeleton } from './SpotOverviewSkeleton'

type Props = {
  /** 表示するスケルトン行数（デフォルト: 5。スマホ 1 画面分） */
  count?: number
}

/**
 * SpotList の形状に合わせたスケルトン。
 * SpotList と同じ divide-y で区切り、ローディング解除時に行の位置が動かないようにする。
 */
export function SpotListSkeleton({ count = 5 }: Props) {
  return (
    <ul data-testid="spot-list-skeleton" aria-hidden="true" className="h-full overflow-hidden divide-y divide-gray-100">
      {Array.from({ length: count }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: 静的なスケルトン行のため index を key に使用
        <li key={i}>
          <SpotOverviewSkeleton />
        </li>
      ))}
    </ul>
  )
}
